import { type FC, useMemo } from 'react'
import type { GetStaticProps, InferGetStaticPropsType } from 'next'
import { QueryClient, dehydrate } from '@tanstack/react-query'

import DeveloperPortal from 'views/Partners/DeveloperPortalPage'

import type { DeveloperPortalProps } from 'views/Partners/DeveloperPortalPage/DeveloperPortal'

import { createFastGrowingCompaniesQuery } from '@segment/api/routes/partners/queries'
import { createClient } from '@segment/api/algolia/client'

import { CatalogClientProvider, createCatalogSearchIndex } from '@segment/contexts/catalogIndex'
import { createStaticSiteBackend, StaticSiteBackendProvider } from '@segment/contexts/staticSiteBackend'

import type { AppExternalPageProps } from '@segment/next-shared/Providers'

const DeveloperPortalPage: FC<InferGetStaticPropsType<typeof getStaticProps>> = ({ amount }) => {
  const staticSiteBackend = useMemo(() => createStaticSiteBackend(), [])
  const catalogClient = createClient()

  return (
    <StaticSiteBackendProvider value={staticSiteBackend}>
      <CatalogClientProvider value={catalogClient}>
        <DeveloperPortal amount={amount} />
      </CatalogClientProvider>
    </StaticSiteBackendProvider>
  )
}

export const getStaticProps: GetStaticProps<AppExternalPageProps & DeveloperPortalProps> = async () => {
  const queryClient = new QueryClient()
  const algoliaClient = createClient()
  const catalogSearchIndex = createCatalogSearchIndex(algoliaClient)

  const props = {
    amount: 8,
  }

  await queryClient.prefetchQuery(
    ...createFastGrowingCompaniesQuery(catalogSearchIndex, {
      amount: props.amount,
    }),
    {
      cacheTime: Infinity,
    }
  )

  return {
    props: {
      ...props,
      dehydratedState: dehydrate(queryClient),
    },
  }
}

export default DeveloperPortalPage
